import { StateCreator } from 'zustand';

export type ChainId = 'bsc' | 'base' | 'sol';

export interface ChainState {
  selectedChain: ChainId;
}

export interface ChainActions {
  setSelectedChain: (chain: ChainId) => void;
}

export type ChainSlice = {
  chain: ChainState & ChainActions;
};

const initialState: ChainState = {
  selectedChain: 'bsc',
};

export const createChainSlice: StateCreator<ChainSlice> = (set) => ({
  chain: {
    ...initialState,

    setSelectedChain: (selectedChain) =>
      set((state) => ({
        chain: { ...state.chain, selectedChain },
      })),
  },
});
